import { render, staticRenderFns } from "./ChatAttachment.vue?vue&type=template&id=fbfc48a0&scoped=true&"
import script from "./ChatAttachment.vue?vue&type=script&lang=js&"
export * from "./ChatAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ChatAttachment.vue?vue&type=style&index=0&id=fbfc48a0&scoped=true&lang=scss&"
import style1 from "./ChatAttachment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfc48a0",
  null
  
)

export default component.exports